"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EPISODIC_WINDOW = exports.EPISODIC_WINDOW_DAYS = void 0;
exports.episodicDeadline = episodicDeadline;
exports.episodicLimit = episodicLimit;
const wasteAccumulation_1 = require("encamp-shared/dist/constants/wasteAccumulation");
Object.defineProperty(exports, "EPISODIC_WINDOW_DAYS", { enumerable: true, get: function () { return wasteAccumulation_1.EPISODIC_WINDOW_DAYS; } });
const date_1 = require("encamp-shared/dist/utils/date");
const relief_1 = require("./relief");
/**
 * The limit subpart L imposes: 60 days from the EVENT's start, not the
 * container's. Federal-stamped in every state, because that is what it is —
 * a state either grants this federal provision or grants nothing (see
 * `SUBPART_L_NOT_ADOPTED`); no state writes its own version of the window.
 */
exports.EPISODIC_WINDOW = {
    kind: "TIME",
    days: wasteAccumulation_1.EPISODIC_WINDOW_DAYS,
    citation: "40 CFR 262 subpart L",
    jurisdiction: "FEDERAL",
};
/**
 * When an event's surge waste must be gone. Always exactly
 * `startDate + EPISODIC_WINDOW_DAYS`, at UTC midnight — nothing persists it,
 * so every lapse question derives from here.
 */
function episodicDeadline(eventStartDate) {
    return (0, date_1.addUtcDays)((0, date_1.floorToUtcMidnight)(eventStartDate), wasteAccumulation_1.EPISODIC_WINDOW_DAYS);
}
/**
 * The episodic limit for one container, or null where subpart L imposes none.
 *
 * This is the whole of what episodic contributes to a container's clock. It
 * does not modify, replace, or know about the facility's standing limit — the
 * composition step holds both and takes the earlier deadline, which is what
 * "a parallel limit that supersedes" actually means.
 */
function episodicLimit(query) {
    if (query.activeEpisodicEvent === null || query.areaType !== "CENTRAL") {
        return null;
    }
    if (!(0, relief_1.getEpisodicRelief)(query).isAvailable) {
        return null;
    }
    return {
        limit: exports.EPISODIC_WINDOW,
        anchorDate: (0, date_1.floorToUtcMidnight)(query.activeEpisodicEvent.startDate),
    };
}
//# sourceMappingURL=window.js.map